/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyCoordinates
 */
export interface PropertyCoordinates {
    /**
     * 
     * @type {number}
     * @memberof PropertyCoordinates
     */
    geoLatitude: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyCoordinates
     */
    geoLongitude: number;
}

export function PropertyCoordinatesFromJSON(json: any): PropertyCoordinates {
    return PropertyCoordinatesFromJSONTyped(json, false);
}

export function PropertyCoordinatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyCoordinates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'geoLatitude': json['geoLatitude'],
        'geoLongitude': json['geoLongitude'],
    };
}

export function PropertyCoordinatesToJSON(value?: PropertyCoordinates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'geoLatitude': value.geoLatitude,
        'geoLongitude': value.geoLongitude,
    };
}


